import {
    AxisLabelsContainer,
    XLabel,
    YLabel,
    XAxisArrow,
    YAxisArrow,
    AxisLetter,
} from './styled';

const AxisLabels = ({ config }) => {
    const { labels } = config;
    const [min, max] = labels.range;
    const span = max - min;

    const values = [];
    for (let v = min + 1; v < max; v += 1) {
        if (v !== 0) values.push(v);
    }

    const toPercent = (v) => ((v - min) / span) * 100;

    return (
        <AxisLabelsContainer>
            {values.map((v) => (
                <XLabel key={`x-${v}`} $left={toPercent(v)}>
                    {v}
                </XLabel>
            ))}
            {values.map((v) => (
                <YLabel key={`y-${v}`} $top={100 - toPercent(v)}>
                    {v}
                </YLabel>
            ))}
            <XAxisArrow />
            <YAxisArrow />
            <AxisLetter $axis="x">x</AxisLetter>
            <AxisLetter $axis="y">y</AxisLetter>
        </AxisLabelsContainer>
    );
};

export default AxisLabels;
